import { Howl } from 'howler';

const playSound = (soundSrc: any, volume: number) => {
  let sound = new Howl({ src: [soundSrc], volume });
  sound.play();
};

export default playSound;
